import { CircularProgress, Typography, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useSnackbar } from "notistack";

import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import ReactJson from 'react-json-view';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import { analyticsIdentifierState, openChatState, SUPPORT_CHAT } from '.';
import { Chat } from './Chat';
import { CustomToaster } from "components/CustomToaster";
import { autoPinCodeProcessingState, autoPinCodeState } from './RecoilState';
import { fingerprintState } from 'util/deviceUUID';
import { toasterror } from 'util/toasterror';


const useStyles = makeStyles((theme) => {
  return {}
})
const BookingCodeProcess = ({ match }) => {
  const serviceId = match?.params?.serviceId
  const code = match?.params?.code

  const classes = useStyles()

  const history = useHistory();

  const [fingerprint, setFingerprint]= useRecoilState(fingerprintState);

  const [booking, setBooking] = useState();

  const { loginPinCodeWithoutClient, getUser, fetchBookingByAuth } = useUserState()
  const { enqueueSnackbar } = useSnackbar()

  const [error, setError] = useState();

  const [complete, setComplete] = useState(false);

  const setAutoPinCode = useSetRecoilState(autoPinCodeState);
  const autoPinCode = useRecoilValue(autoPinCodeState);
  const autoPinCodeProcessing = useRecoilValue(autoPinCodeProcessingState);
  const setAutoPinCodeProcessing = useSetRecoilState(autoPinCodeProcessingState);
  
  const [analyticsIdentifier, setAnalyticsIdentifier] = useRecoilState(analyticsIdentifierState);

  const [onGoing, setOnGoing] = useState(false);

  const processCode = useCallback(
    async () => {
      const user = await getUser(serviceId, false)
      if (user) {
        const bookResult = await fetchBookingByAuth(serviceId, analyticsIdentifier)
        if (bookResult) {
          history.replace(`/bookings/${serviceId}` + history.location.search)
          window?.location?.reload()
        }
        setComplete(true)
        return
      }
      setOnGoing(true)
      setAutoPinCodeProcessing(true)
      try {
        setComplete(false)
        const bookResult = await fetchBookingByAuth(serviceId, analyticsIdentifier)
        setAnalyticsIdentifier(bookResult?.client?.id)
        const requestParams = {
          identifier: bookResult?.white_label_customer?.id || bookResult?.customer?.id || bookResult?.client?.id,
          code: code,
          fingerprint: fingerprint
        }
        
        const loginResult = await loginPinCodeWithoutClient(requestParams)

        setBooking(bookResult)
        setAutoPinCodeProcessing(false)
        setAutoPinCode(null)
        setComplete(true)
        history.replace(`/bookings/${serviceId}` + history.location.search)
        window?.location?.reload()
        return
      } catch (e) {
        const eMessage = e?.response?.data?.message?.en || e?.response?.data?.message || e?.response?.data?.details || e?.message
        setError(e)
        toasterror(eMessage, { error: e })
        setOnGoing(false)
        setAutoPinCode(null)
        setAutoPinCodeProcessing(false)
      }
    },
    [code]
  );
  useEffect(() => {
    if (autoPinCode) {
      processCode()
    }
  }, [autoPinCode]);

  useEffect(
    () => {
      if (code) {
        setAutoPinCode(code)
      }
    }, []
  );

  if (error?.response?.status === 400) {
    return <Alert severity="error">Invalid Pin Code</Alert>
  }

  if (complete) {
    return <Redirect to={{
      ...history.location,
      pathname: `/bookings/${serviceId}`
    }} />
  }

  return (
    <>
      <CircularProgress />
      <Typography variant="h6">Processing Pin Code</Typography>
    </>
  )
}

export { BookingCodeProcess };
